import LegalLayout from './landing/LegalLayout';

function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service">
      <section>
        <h2>Introduction</h2>
        <p>
          These Terms of Service govern your use of EFSoft&apos;s software
          development services and form a legally binding agreement between you
          and EFSoft.
        </p>
      </section>

      <section>
        <h2>Service Description</h2>
        <p>EFSoft provides:</p>
        <ul>
          <li>Custom web application development</li>
          <li>Software consulting and architecture design</li>
          <li>Healthcare, finance, and e-commerce solutions</li>
          <li>Technical support and maintenance services</li>
        </ul>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have questions about these Terms, email us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
        </p>
      </section>
    </LegalLayout>
  );
}

export default TermsOfService;
